export default __webpack_public_path__ + "static/media/roboto-v20-latin-900italic.b97dea3e.svg";